import "./Header.css";

const Header = () => {
  return (
    <header>
      <img src="./img/logo.jpg" alt="img" />
    </header>
  );
};

export default Header;
